import React from 'react';
import Courses from '../components/courses';
const Home: React.FunctionComponent = () => {

  return (
    <div className="home">
      <Courses />
    </div>
  );
}

export default Home;
